<template>
  <div class="main" :class="{ 'collapse-w': showAside }">
    <el-menu :collapse-transition="true" :default-active="activeId" :collapse="showAside" :unique-opened="true"
      class="el-menu-vertical-demo" background-color="transparent" text-color="#ffffffb3" active-text-color="#fff"
      :class="{ 'submenu-bg': showAside }">
      <template v-for="(item, index) in MenuS">
        <el-menu-item :class="{ 'back-col': item.id === activeId }" :key="index" :index="item.id"
          v-if="item.children.length <= 0" @click="curMenu(item)">
          <i :class="item.icon"></i>
          <span class="name" slot="title">{{ item.name }}</span>
          <i v-if="item.id === activeId && !showAside" class="el-icon-caret-right"></i>
        </el-menu-item>

        <el-submenu v-if="item.children.length > 0" :key="index" :index="item.id">
          <template slot="title">
            <i :class="item.icon"></i>
            <span class="name" slot="title">{{ item.name }}</span>
          </template>

          <el-menu-item style="margin: 6px 0" v-for="(it, inx) in item.children"
            :class="{ 'back-col': it.id === activeId }" :key="inx" :index="it.id" @click="curMenu(it)">
            <i :class="it.icon"></i>
            <span slot="title">{{ it.name }}</span>
            <i v-if="it.id === activeId && !showAside" class="el-icon-caret-right r-i"></i>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <div class="menu-footer">
      <div class="fold-icon" @click="toggle">
        <i :class="!showAside ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { setStore, getStore, removeStore } from "@/util/store";
export default {
  components: {},
  props: {},
  data() {
    return {
      showAside: false,
      logoBlue: require("@/assets/images/logo/logo_blue.png"),
      MenuS: []
    };
  },
  computed: {
    ...mapGetters(["menus", "activeId"])
  },
  watch: {
    menus(menu) {
      this.MenuS = menu;
    }
  },
  created() {
    this.MenuS = getStore({ name: "menus" });
  },
  mounted() { },
  methods: {
    curMenu(item) {
      // 清除表格行数据
      this.$store.commit('removeTableRow');
      removeStore({ name: "corpBasicNav" });
      removeStore({ name: "toDoNav" });
      removeStore({ name: "parentPath" });

      setStore({ name: "activeId", content: item.id });
      this.$store.commit("activeId", item.id);

      setStore({ name: "nodeInfo", content: item });
      this.$store.commit("nodeInfo", item);
      let path = item.routerPath;
      if (path?.includes("/:node")) {
        path = path.replace("/:node", `/${item.name}`);
      }
      this.$router.push({ path });
    },
    toggle() {
      this.showAside = !this.showAside;
      this.$store.commit("showAside", this.showAside);
    }
  }
};
</script>
<style scoped lang="scss">
// 基础样式
.main {
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #001529;
  transition: width 0.3s ease-in-out;

  // 菜单标题样式
  .name {
    font-size: 16px !important;
    transition: all 0.2s ease;
  }

  // 菜单容器
  .el-menu {
    width: 100%;
    height: 100%;
    border-right: none;
    padding-top: 15px;

    // 子菜单箭头
    ::v-deep .el-submenu__icon-arrow {
      font-size: 16px;
      transition: transform 0.3s ease;
    }

    // 子菜单展开时旋转箭头
    ::v-deep .el-submenu.is-opened .el-submenu__icon-arrow {
      transform: rotate(180deg);
    }

    // 菜单项
    .el-menu-item {
      position: relative;
      margin: 0 !important;
      height: 56px !important;
      line-height: 56px !important;
      // padding: 0 20px !important;
      transition: all 0.2s ease;

      // 选中项指示箭头
      .el-icon-caret-right {
        font-size: 28px;
        position: absolute;
        right: -13px;
        top: 14px;
        color: #165dff;
        margin: 0 !important;
        transition: all 0.3s ease;
      }

      .r-i {
        top: 12px !important;
      }

      // 图标样式
      i {
        font-size: 18px !important;
        margin-right: 12px !important;
        width: 20px !important;
        text-align: center;
      }
    }

    // 子菜单样式
    ::v-deep .el-submenu__title {
      height: 56px !important;
      line-height: 56px !important;
      padding: 0 20px !important;
      transition: all 0.2s ease;

      i {
        font-size: 18px !important;
        margin-right: 12px !important;
        width: 20px !important;
        text-align: center;
      }
    }

    // 子菜单展开列表
    ::v-deep .el-menu--inline {
      background-color: #0f2a44 !important;
    }

    // 子菜单标题悬停
    ::v-deep .el-submenu__title:hover {
      background: rgba(255, 255, 255, 0.05) !important;
      color: #fff !important;
    }

    // 菜单项悬停
    .el-menu-item:hover {
      background: rgba(255, 255, 255, 0.05) !important;
      color: #fff !important;
    }

    // 活跃状态样式
    .back-col {
      background-color: #165dff !important;
      color: #fff !important;
      position: relative;

      &:hover {
        background-color: #165dff !important;
      }
    }
  }

  // 底部折叠按钮区域
  .menu-footer {
    height: 56px;
    width: 100%;
    display: flex;
    align-items: center;
    // justify-content: center;
    border-top: 1px solid rgba(255, 255, 255, 0.05);

    .fold-icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.05);
      }

      i {
        font-size: 18px;
        color: #999;
        transition: all 0.3s ease;
      }

      &:hover i {
        color: #165dff;
        transform: scale(1.1);
      }
    }
  }
}

// 折叠状态
.collapse-w {
  width: 64px !important;
  transition: width 0.3s ease-in-out;

  .el-menu-item,
  ::v-deep .el-submenu__title {
    padding: 0 18px !important;
    justify-content: center;

    i {
      margin-right: 0 !important;
    }
  }

  .name {
    display: none;
  }

  .el-menu-item .el-icon-caret-right {
    display: none !important;
  }
}

// 子菜单背景样式
::v-deep .submenu-bg {
  .is-active {
    background: #165dff;

    i {
      color: #fff !important;
    }
  }
}

// 子菜单展开动画
::v-deep .el-submenu .el-menu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}

::v-deep .el-submenu.is-opened .el-menu {
  max-height: 500px;
  transition: max-height 0.5s ease-in;
}

// 响应式调整
@media (max-width: 768px) {
  .main {
    position: fixed;
    z-index: 100;
    height: 100vh;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  }
}
</style>
